import { css } from '@/styled-system/css';

/**
 * Floating close button styles extracted from FullscreenOverlay
 * Applied only when variant="floating"
 *
 * Source: fullscreenOverlay.styles.ts lines 304-330
 */
export const floatingCloseButton = css({
  position: 'absolute',
  top: '2x',
  left: '2x',
  bg: 'rgba(255, 255, 255, 0.9)',
  border: 'none',
  transitionProperty: 'all',
  transitionDuration: '0.2s',
  zIndex: 'zIndexOverParent',

  '&:hover': {
    bg: 'rgba(255, 255, 255, 1)',
    transform: 'scale(1.05)',
  },

  '&:focus-visible': {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});
